import { z } from 'zod';

const promoDiscount = z.object({
    receiptItem: z.string(),
    type: z.enum(['fixed', 'percentage', 'amount']),
    value: z.number(),
});
const countdownConf = z.object({ alternativeSubtitle: z.string() });
const assetsPromo = z.object({
    resourceName: z.string().optional(),
    resourceUrl: z.string().optional(),
});
const promoContent = z.object({
    name: z.string(),
    title: z.string(),
    subtitle: z.string(),
    countdown: z.optional(countdownConf),
    assets: assetsPromo,
});
z.object({
    name: z.string(),
    giftProducts: z.array(z.string()),
    status: z.enum([
        'DRAFT',
        'BLOCKED',
        'SCHEDULED',
        'RUNNING',
        'CANCELLED',
        'DONE',
    ]),
    type: z.enum(['EXTRACTION', 'LIST', 'USERID']),
    userId: z.string().optional(),
    adIds: z.array(z.string()).optional(),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    purchasedProducts: z.array(z.string()).optional(),
});
const infoPromo = z.object({
    id: z.string(),
    channels: z.array(z.string()),
    startDate: z.string(),
    endDate: z.string(),
    criteria: z.array(z.record(z.string(), z.string())),
    discounts: z.array(promoDiscount),
    content: promoContent,
});
const promotions = z.object({
    promo: z.array(infoPromo),
});
const voucherValidatedOrderItem = z.object({
    productID: z.string(),
    amount: z.number(),
    subtotalAmount: z.number(),
});
const voucherValidatedOrder = z.object({
    amount: z.number(),
    totalAmount: z.number(),
    items: z.array(voucherValidatedOrderItem),
});

export { assetsPromo, countdownConf, infoPromo, promoContent, promoDiscount, promotions, voucherValidatedOrder, voucherValidatedOrderItem };
//# sourceMappingURL=zod.js.map
